import styled from '@emotion/styled'

// It would be always just a div with no styles but I prefer to create such named component
// so I can easily understand purpose of this div in the code
export const EmptyTile = styled.div``
